<template>
  <div :class="[
    'case-wrapper',
    priorityStyle(caseItem.priority),
    { 'pinned-case': caseItem.is_pinned },
  ]">
    <div v-if="caseItem.is_pinned" class="pin-ribbon"></div>

    <div class="card-body mb-1 mb-md-0">
      <div v-if="currentRole === 'owner'" class="d-md-block d-none dropdown text-right mb-3 mr-3">
        <a href="javascript:void(0)" class="dots" role="button" id="dropdownMenuLink" data-toggle="dropdown"
          aria-haspopup="true" aria-expanded="false">
          <img src="/assets/img/1.0/three-dots.png" alt="Options" />
        </a>

        <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
          <template v-if="isArchived">
            <a class="dropdown-item" href="javascript:void(0)" @click.prevent="restoreCase(caseItem)">
              <i class="fa fa-reply"></i>&nbsp;{{ __('Restore Case') }}
            </a>
            <a class="dropdown-item text-danger" href="javascript:void(0)" @click.prevent="deleteCase(caseItem)">
              <i class="fa fa-trash"></i>&nbsp;{{ __('Delete Case') }}
            </a>
          </template>
          <template v-else>
            <a class="dropdown-item" href="javascript:void(0)" @click.prevent="pinCase(caseItem, !caseItem.is_pinned)">
              <i class="fas fa-map-pin"></i>&nbsp;{{ caseItem.is_pinned ? __('Unpin Case') : __('Pin Case') }}
            </a>
            <a class="dropdown-item" href="javascript:void(0)" @click.prevent="navigateToTab('case-create', caseItem.id)">
              <i class="fas fa-edit"></i>&nbsp;{{ __('Edit Case') }}
            </a>
            <a class="dropdown-item text-danger" href="javascript:void(0)" @click.prevent="archiveCase(caseItem)">
              <i class="fa fa-archive"></i>&nbsp;{{ __('Resolve Case') }}
            </a>
          </template>
        </div>
      </div>

      <div class="d-flex flex-wrap align-items-center mb-3">
        <h5 class="m-0 header-case">
          <i v-if="caseItem.is_pinned" class="fas fa-map-pin pin-icon"></i>
          {{ caseItem.title }}
        </h5>
        <span v-if="caseItem.review" class="badge badge-success mx-1">
          {{ __('Review') }}
        </span>
        <span v-if="caseItem.survey" class="badge badge-success mx-1">
          {{ __('Survey') }}
        </span>
        <span :class="['badge', priorityBadgeClass(caseItem.priority)]" class="mx-1">
          {{ __(formatPriority(caseItem.priority)) }}
        </span>
        <span :class="['badge', typeBadgeClass(caseItem.type)]" class="mx-1">
          {{ __(caseItem.type) }}
        </span>
        <span :class="['badge', statusBadgeClass(caseItem.status)]" class="mx-1">
          {{ __(caseItem.status) }}
        </span>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="d-flex align-items-center mb-1">
            <strong class="mr-2">{{ __('Created At') }}:</strong>
            <p class="mb-0">{{ formatDate(caseItem.created_at) }}</p>
          </div>
          <div class="d-flex align-items-center mb-1">
            <strong class="mr-2">{{ __('Last Update') }}:</strong>
            <p class="mb-0">{{ formatDate(caseItem.updated_at) }}</p>
          </div>
          <div class="d-flex align-items-center mb-1">
            <strong class="mr-2">{{ __('Created By') }}:</strong>
            <p class="mb-0">{{ caseItem.created_by.name }}</p>
          </div>
            <div
            class="d-flex align-items-center mb-1 flex-wrap"
            v-if="caseItem.departments && caseItem.departments.length"
            >
            <strong class="mr-2">{{ __('Departments') }}:</strong>
            <p class="mb-0">
              <span
              v-for="(department, index) in caseItem.departments"
              :key="index"
              class="badge badge-success mx-1"
              >
              {{ labelizeGeneral(department.name) }}
              </span>
            </p>
            </div>
        </div>
      </div>

      <div class="d-md-none d-block actions-row d-flex justify-content-around my-3">
        <template v-if="isArchived">
          <button class="btn btn-outline-secondary btn-sm" @click.prevent="restoreCase(caseItem)">
            <i class="fa fa-reply"></i> {{ __('Restore') }}
          </button>
          <button class="btn btn-outline-danger btn-sm" @click.prevent="deleteCase(caseItem)">
            <i class="fa fa-trash"></i> {{ __('Delete') }}
          </button>
        </template>
        <template v-else>
          <button class="btn btn-outline-secondary btn-sm" @click.prevent="pinCase(caseItem, !caseItem.is_pinned)">
            <i class="fas fa-map-pin"></i> {{ caseItem.is_pinned ? __('Unpin') : __('Pin') }}
          </button>
          <button class="btn btn-outline-secondary btn-sm" @click.prevent="navigateToTab('case-create', caseItem.id)">
            <i class="fas fa-edit"></i> {{ __('Edit') }}
          </button>
          <button class="btn btn-outline-danger btn-sm" @click.prevent="archiveCase(caseItem)">
            <i class="fa fa-archive"></i> {{ __('Resolve') }}
          </button>
        </template>
      </div>
    </div>

    <div class="detailed-view">
      <a aria-controls="case-create" data-toggle="tab" class="btn btn-primary btn-small"
        @click.prevent="navigateToTab('case-details', caseItem.id)">
        {{ __('Detailed View') }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CaseCard',
  props: {
    caseItem: {
      type: Object,
      required: true,
    },
    currentRole: {
      type: String,
      required: true,
    },
    isArchived: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    pinCase(caseItem, status) {
      this.$emit('pin-case', caseItem, status);
    },

    navigateToTab(tab, caseId) {
      this.$emit('navigate-tab', tab, caseId);
    },

    archiveCase(caseItem) {
      this.$emit('archive-case', caseItem);
    },

    restoreCase(caseItem) {
      this.$emit('restore-case', caseItem);
    },

    deleteCase(caseItem) {
      this.$emit('delete-case', caseItem);
    },

    priorityStyle(priority) {
      return {
        0: 'low-priority',
        1: 'medium-priority',
        2: 'high-priority',
      }[priority] || '';
    },

    priorityBadgeClass(priority) {
      return {
        2: 'badge-danger',
        1: 'badge-warning',
        0: 'badge-success',
      }[priority] || 'badge-light';
    },

    statusBadgeClass(status) {
      return {
        new: 'badge-primary',
        open: 'badge-dark',
        closed: 'badge-success',
      }[status.toLowerCase()] || 'badge-light';
    },

    typeBadgeClass(type) {
      return {
        task: 'badge-secondary',
        issue: 'badge-warning',
        request: 'badge-info',
      }[type.toLowerCase()] || 'badge-light';
    },

    formatDate(date) {
      return new Date(date).toLocaleString();
    },

    formatPriority(priority) {
      return {
        0: __('Low'),
        1: __('Medium'),
        2: __('High'),
      }[priority] || '';
    },
  },
};
</script>

<style scoped>
p {
  padding-top: 0;
}
.case-wrapper {
  border: 1px solid #e9eaec;
  margin: 0 0 40px 0;
  border-radius: 3px;
  position: relative;
  transition: box-shadow 0.3s ease;
}

.case-wrapper:hover {
  box-shadow: 0 0 18px rgba(0, 0, 0, 0.05);
  /* Subtle shadow */
}

/* Warning Tape Ribbon (10px high, repeated) */
.pinned-case {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  /* Light shadow around the card */
}

.pin-ribbon {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 6px;
  background: repeating-linear-gradient(45deg, #ca3438, #ca3438 5px, #fff 5px, #fff 10px);
  z-index: 1;
}

.pin-icon {
  color: #ca3438;
  font-size: 16px;
  margin-right: 8px;
}

.high-priority {
  border-left: 3px solid #ca3438;
}

.medium-priority {
  border-left: 3px solid #ffcc29;
}

.low-priority {
  border-left: 3px solid #01e001;
}

.dots {
  cursor: pointer;
  position: absolute;
  padding: 0;
}

.detailed-view {
  position: absolute;
  bottom: -15px;
  right: 30px;
  display: flex;
  align-items: center;
}

.badge {
  font-size: 12px;
  text-transform: capitalize;
}
</style>
